
import axios from 'axios';


export const  axios_gammesnew_getgammescompagnie = async (compagnie_mini)=>{
    return  await axios.post(`/gammesnew/getgammescompagnie/`,{compagnie_mini},{headers:{'Accept':'application/json',"Content-Type":"application/json"}});
}


export const  axios_gammesnew_getallgammes = async ()=>{
   return await axios.get(`/gammesnew/getallgammes`,{headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'   }});
}